module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-epc@2x-71a46e9b5420084e9261751c5da32e3f.png";